import {
  Alert,
  type AlertProps,
  AlertTitle,
  Snackbar as MuiSnackbar,
  type SxProps,
  type Theme
} from '@mui/material'

export type MolsonSnackbarProps = Pick<AlertProps, 'severity'> & {
  title?: string
  message: string
  open: boolean
  onClose: () => void
  sx?: SxProps<Theme>
  autoHideDuration?: number
  closableToast?: boolean
}

export const MolsonSnackbar = ({
  onClose,
  open,
  title,
  message,
  severity,
  autoHideDuration = 6000,
  closableToast = false,
  sx
}: MolsonSnackbarProps) => {
  return (
    <MuiSnackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      autoHideDuration={autoHideDuration}
      open={open}
      onClose={onClose}
      sx={sx}
    >
      <Alert
        severity={severity}
        sx={{ width: '100%' }}
        onClose={closableToast ? onClose : undefined}
      >
        {title && <AlertTitle>{title}</AlertTitle>}
        {message}
      </Alert>
    </MuiSnackbar>
  )
}
